import React from 'react';
import moment from 'moment-timezone';
import { DatePicker } from 'antd';

import { FULL_DATE_FORMAT } from '../constants/date';

const { RangePicker } = DatePicker;

const DateRangePicker = ({ zoneId, onChangeRange, from, to }) => (
  <RangePicker
    value={[moment.tz(from, zoneId), moment.tz(to, zoneId).subtract(1, 'days')]}
    onChange={([fromParam, toParam]) =>
      onChangeRange(
        fromParam.format(FULL_DATE_FORMAT),
        toParam.add(1, 'days').format(FULL_DATE_FORMAT)
      )
    }
    allowClear={false}
    style={{ marginLeft: 8 }}
  />
);

export default DateRangePicker;
